import React, { useEffect, useRef } from 'react';
import './App.css';

function App() {
	const starsRef = useRef<HTMLDivElement>(null);
	const shootingStarsRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const createStar = () => {
			if (!starsRef.current) return;
			const star = document.createElement('div');
			star.className = 'dynamic-star';
			const x = Math.random() * 100;
			const y = Math.random() * 100;
			const size = Math.random() * 2 + 1; // 1px a 3px
			const duration = Math.random() * 3 + 2; // 2s a 5s
			const delay = Math.random() * 2;
			star.style.cssText = `
				position: absolute;
				top: ${y}%;
				left: ${x}%;
				width: ${size}px;
				height: ${size}px;
				background: #fff;
				border-radius: 50%;
				box-shadow: 0 0 ${size * 2}px rgba(255, 255, 255, 0.8);
				animation: starTwinkle ${duration}s ease-in-out infinite;
				animation-delay: ${delay}s;
			`;
			starsRef.current.appendChild(star);
			setTimeout(() => {
				if (star.parentNode) star.parentNode.removeChild(star);
			}, duration * 1000);
		};

		// Sistema de estrelas cadentes CSS estático com intervalo dinâmico
		const createShootingStar = () => {
			if (!shootingStarsRef.current) return;
			
			// Criar span para estrela cadente
			const shootingStar = document.createElement('span');
			shootingStar.className = 'shooting-star-css';
			
			// Posição aleatória - todas vêm da direita para a esquerda
			const startY = Math.random() * 100; // Altura aleatória
			const startX = 100 + Math.random() * 20; // 100-120% (fora da tela à direita)
			
			// Duração aleatória
			const duration = 1 + Math.random() * 2; // 1s a 3s
			
			// Aplicar estilos CSS
			shootingStar.style.cssText = `
				position: absolute;
				top: ${startY}%;
				left: ${startX}%;
				width: 4px;
				height: 4px;
				background: #fff;
				border-radius: 50%;
				box-shadow: 0 0 0 4px rgba(255,255,255,0.1),0 0 0 8px rgba(255,255,255,0.1),0 0 20px rgba(255,255,255,0.1);
				animation: shootingStarMove ${duration}s linear forwards;
				z-index: 2;
				pointer-events: none;
			`;
			
			// Adicionar rastro via ::before
			shootingStar.setAttribute('data-trail', 'true');
			
			shootingStarsRef.current.appendChild(shootingStar);
			
			// Remover após animação
			setTimeout(() => {
				if (shootingStar.parentNode) {
					shootingStar.parentNode.removeChild(shootingStar);
				}
			}, duration * 1000);
		};

		// Configuração do intervalo entre estrelas cadentes (em segundos)
		const SHOOTING_STAR_INTERVAL = 30; // 30 segundos entre cada estrela (muito mais raro)
		
		// Muitas mais estrelas brilhando: intervalo muito mais curto
		const starInterval = setInterval(createStar, 50);
		// E muito mais estrelas iniciais
		for (let i = 0; i < 120; i++) setTimeout(createStar, i * 40);
		
		// Sistema de estrelas cadentes com intervalo configurável
		const shootingStarInterval = setInterval(createShootingStar, SHOOTING_STAR_INTERVAL * 1000);
		
		// Criar algumas estrelas cadentes iniciais com delays aleatórios
		for (let i = 0; i < 3; i++) {
			const randomDelay = Math.random() * SHOOTING_STAR_INTERVAL * 1000;
			setTimeout(createShootingStar, randomDelay);
		}
		
		return () => {
			clearInterval(starInterval);
			clearInterval(shootingStarInterval);
			if (starsRef.current) starsRef.current.innerHTML = '';
			if (shootingStarsRef.current) shootingStarsRef.current.innerHTML = '';
		};
	}, []);

	return (
		<div className="App">
			<div className="construction-container" style={{ backgroundImage: 'url(/background.png)' }}>
				{/* Estrelas dinâmicas de brilho */}
				<div ref={starsRef} className="stars-container"></div>

				{/* Container para estrelas cadentes CSS estáticas */}
				<div ref={shootingStarsRef} className="shooting-stars-container"></div>

				{/* Logo como parte do fundo */}
				<div className="astra-logo-background">
					<img src="/astra-logo.png" alt="Astra Studios" className="logo-image" />
				</div>

				<div className="content">
					<h1 className="title">SITE EM CONSTRUÇÃO</h1>
					<p className="subtitle">Estamos trabalhando para trazer algo incrível!</p>

					<div className="contact-buttons">
						<a href="mailto:contato@astrastudios.com.br" className="contact-btn email">
							<svg className="icon" viewBox="0 0 24 24" fill="currentColor">
								<path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v 2z"/>
							</svg>
							<span>E-mail</span>
						</a>

						<a href="https://www.instagram.com/astrastudiosofc" target="_blank" rel="noopener noreferrer" className="contact-btn instagram">
							<svg className="icon" viewBox="0 0 24 24" fill="currentColor">
								<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
							</svg>
							<span>Instagram</span>
						</a>

						<a href="https://discord.gg/T7vkEg8ZSP" target="_blank" rel="noopener noreferrer" className="contact-btn discord">
							<svg className="icon" viewBox="0 0 24 24" fill="currentColor">
								<path d="M20.317 4.3698a19.7913 19.7363 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0189 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1568 2.4189Z"/>
							</svg>
							<span>Discord</span>
						</a>

						<a href="https://www.facebook.com/astrastudiosofc" target="_blank" rel="noopener noreferrer" className="contact-btn facebook">
							<svg className="icon" viewBox="0 0 24 24" fill="currentColor">
								<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
							</svg>
							<span>Facebook</span>
						</a>

						<a href="https://x.com/astrastudiosofc" target="_blank" rel="noopener noreferrer" className="contact-btn x-twitter">
							<svg className="icon" viewBox="0 0 24 24" fill="currentColor">
								<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
							</svg>
							<span>X (Twitter)</span>
						</a>

						<a href="https://www.youtube.com/@astrastudiosofc" target="_blank" rel="noopener noreferrer" className="contact-btn youtube">
							<svg className="icon" viewBox="0 0 24 24" fill="currentColor">
								<path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
							</svg>
							<span>YouTube</span>
						</a>

						{/*<a href="https://www.tiktok.com/@astrastudiosofc" target="_blank" rel="noopener noreferrer" className="contact-btn tiktok">
							<svg className="icon" viewBox="0 0 24 24" fill="currentColor">
								<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
							</svg>
							<span>TikTok</span>
						</a>*/}
						
					</div>

					<footer className="footer">
						<p>© 2025 Astra Studios. Todos os direitos reservados.</p>
					</footer>
				</div>
			</div>
		</div>
	);
}

export default App;
